import { BaseFloatingPane } from 'interfaces/floatingPanes'
import { AccountUid } from 'interfaces/linkage'
import { AccountsFilteredPage } from 'interfaces/pages'

export const PAGE_FILTER_PANE = 'page-filter' as const

type FilterByAccountPane = {
  mode: 'by-account'
  page: AccountsFilteredPage
}

export type PageFilterPane =
  & BaseFloatingPane
  & (
    | FilterByAccountPane
  )
  & {
    type: typeof PAGE_FILTER_PANE
  }

type PageFilters = {
  comparison: boolean
  disabled_accounts: AccountUid[]
}

type FiltersApiResponse = {
  are_comparisons_enabled: boolean
  excluded_account_uids: AccountUid[]
}

export type WithPageFiltersApiResponse = {
  filters: Partial<FiltersApiResponse>
}

export type WithPageFiltersApiRequest = {
  filters: Partial<FiltersApiResponse>
}


export type PageFiltersPreferencesAppState =
  & PageFilters
  & {

  }
